<script>
import AdminSideBar from '@/commons/admin-sidebar-menu';

export default {
  name: 'MobileTopNav',
  components: {},
  data() {
    return {
      sidebars: AdminSideBar
    };
  },
  methods: {
    toggleMenu: function() {
      this.$store.dispatch('common/toggleSidebar');
    }
  }
};
</script>

<template lang="pug">
  .content
    .clearfix
      .w-100
        .inline.mr-xl.toggle-menu-buton(v-on:click="toggleMenu()")
          img(src='/img/mb-menu.png')
        .inline.page-name
          span.font-medium(v-for="item in sidebars" v-show="$route.name === item.route") {{item.name}}
</template>

<style lang="scss" scoped>
</style>
